import {Component, Input} from '@angular/core';
import {ColumnFormComponent} from "../column-form.component";
import {IExcelColumn} from "../../model/interface/excel-column.interface";
import {ISimpleSelectableDataList} from "../../model/interface/simple-selectable-data.model.interface";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {map} from "rxjs/operators";
import {CustomValidators} from "../../validator/customValidators";
import {DepartmentService} from "../../../core/services/department.service";

@Component({
  selector: 'app-department-column-form',
  templateUrl: './department-column-form.component.html',
  styleUrls: ['./department-column-form.component.css']
})
export class DepartmentColumnFormComponent extends ColumnFormComponent {

  @Input() column: IExcelColumn;
  departments: ISimpleSelectableDataList;
  form: FormGroup;
  innerForm: FormArray;

  get select() {
    return this.form.get('select');
  }

  get props() {
    return this.form.get('departments');
  }

  get columnForm(): FormGroup {
    return this.form;
  }

  get resultForm(): FormArray {
    return this.innerForm;
  }

  constructor(private fb: FormBuilder,
              private departmentService: DepartmentService) {
    super();
    this.form = this.createColumnForm();
    this.innerForm = this.createInnerForm()

    this.select.valueChanges
        .subscribe(_ => this.props.updateValueAndValidity());


    this.form.valueChanges
        .pipe(map(_ => this.flat(this.form.value)))
        .subscribe(controls => this.replaceInnerFormWithControls(controls));


  }

  private replaceInnerFormWithControls(controls: FormGroup[]) {
    this.innerForm.clear();
    controls.forEach(c => this.innerForm.push(c));
  }

  private createInnerForm() {
    return this.fb.array([]);
  }

  private createColumnForm() {
    return this.fb.group({
      [this.TYPE_FIELD]: [null, Validators.required],
      select: [false],
      departments: [[], CustomValidators.conditionalValidator(() => this.select.value,
          Validators.required)]
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.fetchDepartments();
  }

  flat(form): FormGroup[] {
    return form.departments?.map(
        departmentId => this.fb.group({
          [this.TYPE_FIELD]: form[this.TYPE_FIELD],
          select: form.select,
          departmentId: departmentId
        })
    )
  }

  private fetchDepartments() {
    this.departmentService.getAll().pipe(
        map(data => data.toSimpleSelectableDataList())
    ).subscribe(data => this.departments = data);
  }
}
